import {
  FarmerRegistration,
  Profile,
} from "@/features/farmer/domain/farmer-interface";
import {
  farmerRegistration,
  getProfile,
  logout,
} from "@/features/farmer/data/datasources/farmer-datasources";

export interface FarmerRepository {
  _getProfile: (farmerId: string) => Promise<Profile | undefined>;
  _logout: () => Promise<string | undefined>;
  _farmerRegistration: (
    farmerInfo: FarmerRegistration
  ) => Promise<string | undefined>;
}

export class FarmerRepositoryImpl implements FarmerRepository {
  _getProfile = async (farmerId: string): Promise<Profile | undefined> => {
    return await getProfile(farmerId);
  };

  _logout = async (): Promise<string | undefined> => {
    return await logout();
  };

  _farmerRegistration = async (
    farmerInfo: FarmerRegistration
  ): Promise<string | undefined> => {
    return await farmerRegistration(farmerInfo);
  };
}
